var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g2, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOnboardingVistoriaSearch = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 210,
  height: 210,
  viewBox: "0 0 210 210",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M45.1919 187.908C67.0889 187.908 84.8399 184.072 84.8399 179.34C84.8399 174.608 67.0889 170.772 45.1919 170.772C23.295 170.772 5.54395 174.608 5.54395 179.34C5.54395 184.072 23.295 187.908 45.1919 187.908Z",
  fill: "#E2E2E2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.13,
  d: "M189.84 15.0149H20.16C15.5208 15.0149 11.76 18.7757 11.76 23.4149V126.567C11.76 131.206 15.5208 134.967 20.16 134.967H189.84C194.479 134.967 198.24 131.206 198.24 126.567V23.4149C198.24 18.7757 194.479 15.0149 189.84 15.0149Z",
  fill: "white"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M189.861 15.386H19.845C15.3914 15.386 11.781 18.9964 11.781 23.45V125.496C11.781 129.95 15.3914 133.56 19.845 133.56H189.861C194.315 133.56 197.925 129.95 197.925 125.496V23.45C197.925 18.9964 194.315 15.386 189.861 15.386Z",
  fill: "white",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.781 113.869H197.925",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.781 94.1709H197.925",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.781 74.4729H197.925",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.781 54.782H197.925",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.781 35.084H197.925",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.901 15.386V133.56",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.877 15.386V133.56",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.853 15.386V133.56",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.8291 15.386V133.56",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.8049 15.386V133.56",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M126.077 33.5579H59.3601V173.348H126.077V33.5579Z",
  fill: "#A7F9DC",
  stroke: "#00AD66",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M117.187 104.09L72.4919 104.72V33.7888H117.187V104.09Z",
  fill: "#8AE2C0"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M125.762 33.523L132.503 32.781L186.165 53.543L184.254 192.549L180.39 194.985",
  fill: "#EE8322"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M59.3601 121.884L72.0721 104.727L117.187 104.09L125.447 116.802L125.762 173.32L59.3601 173.355V121.884Z",
  fill: "#A7F9DC",
  stroke: "#00AD66",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M117.187 104.09L117.607 33.5579",
  stroke: "#00AD66",
  strokeMiterlimit: 10
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M72.072 104.937L72.492 33.5579",
  stroke: "#00AD66",
  strokeMiterlimit: 10
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M19.103 165.529L15.722 170.023C15.169 170.695 15.155 171.661 15.694 172.354L21.119 179.333C21.469 179.781 21.98 180.075 22.54 180.159L30.31 181.251C32.711 181.587 34.16 178.535 31.962 177.191C29.127 175.462 27.265 172.368 25.816 169.456",
  fill: "#0E1010"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7349 107.002L24.8499 133.483L18.6199 165.753L27.2999 171.094L35.5319 142.604L35.7559 109.228",
  fill: "#ACACAC"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M34.251 171.136L35.805 179.872C36.071 180.817 37.037 181.482 38.136 181.482L54.999 181.51C58.338 181.51 59.206 177.408 56.07 176.386C56.028 176.372 55.979 176.358 55.937 176.344C51.443 174.958 44.492 172.137 44.492 172.137",
  fill: "#0E1010"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M23.0581 96.25C22.1831 98.28 21.9591 98.315 21.4061 100.457C19.8241 106.547 22.2461 111.713 25.8931 116.494C27.1601 118.153 30.0861 125.405 31.6891 130.284C32.3891 132.405 32.7811 134.617 32.8721 136.843L34.2581 171.136L44.7861 172.13C44.9541 167.37 48.5731 137.207 48.5731 137.207C48.7551 135.268 48.7621 133.322 48.5801 131.383L45.5211 98.259",
  fill: "#D7D8D6"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M36.778 70.7069L45.542 76.9299L51.177 70.5879L53.718 71.0779C55.755 71.3019 55.944 69.0059 56.168 67.5849C56.343 66.4789 56.518 65.3659 56.693 64.2599C57.092 64.4069 57.603 64.5259 57.876 64.2039C58.051 64.0009 58.037 63.6999 58.016 63.4269C57.862 61.5579 57.701 59.6889 57.288 57.8619C56.847 55.9299 56.322 53.1649 54.173 52.6119C51.681 51.9679 49.049 52.5699 46.55 53.2209C44.205 53.8299 42.812 55.6709 42.161 57.9739C41.86 59.0449 41.769 60.1789 41.909 61.2779C41.944 61.5789 42.903 64.4279 42.959 64.3719L36.771 70.7139",
  fill: "#C1813E"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M54.4319 61.4319C54.3759 61.6769 54.5299 61.9149 54.7749 61.9639C55.0199 62.0199 55.2579 61.8659 55.3069 61.6209C55.3629 61.3759 55.2089 61.1379 54.9639 61.0889C54.7189 61.0329 54.4809 61.1869 54.4319 61.4319Z",
  fill: "#0E1010"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M49.7139 59.2899C50.0989 58.3659 50.6939 57.7149 52.0449 57.6239C53.1089 57.5539 54.1729 57.7919 55.2369 57.7639C55.9719 57.7429 56.7069 57.5959 57.3859 57.3299C57.9529 57.1059 58.4849 56.8049 58.9329 56.3919C60.1649 55.2579 60.5429 53.3049 59.8639 51.7719C59.1849 50.2389 57.8549 49.2589 56.1819 49.3919C54.4319 49.5319 52.9199 50.6169 51.2959 51.2959C49.9239 51.8699 48.4259 52.1639 46.9349 52.1429C45.5279 52.1289 44.0579 51.8419 42.7419 52.3389C42.0419 52.6049 41.4329 53.0809 40.9149 53.6269C39.3259 55.3069 38.5699 57.6729 38.5839 59.9899C38.5909 62.3349 39.2209 65.6809 41.9649 66.2409C43.1549 66.4859 44.4639 66.0379 45.2549 65.1139C44.5899 64.5749 43.9039 64.0219 43.5959 63.2239C43.3369 62.5589 43.3789 61.7889 43.6309 61.1169C43.8129 60.6269 44.1069 60.1649 44.5199 59.8429C45.0799 59.4089 45.8569 59.2689 46.5359 59.4789C47.2149 59.6889 47.7749 60.2419 47.9919 60.9139C48.0549 61.1029 48.1039 61.3199 48.2649 61.4389C48.4679 61.5929 48.7759 61.5089 48.9509 61.3339C49.1259 61.1589 49.2099 60.8999 49.2729 60.6549C49.4129 60.1579 49.5389 59.6889 49.7139 59.2759V59.2899Z",
  fill: "black"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_31451_19906",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 49,
  y: 70,
  width: 3,
  height: 3
}, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M51.1769 70.5808L49.3569 72.6318L51.1769 70.5808Z",
  fill: "white"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_31451_19906)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M51.1769 70.5808H49.3569V72.6318H51.1769V70.5808Z",
  fill: "#EBB990"
}))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M47.2429 69.7268L49.3569 72.6318L51.1769 70.5808L47.2429 69.7268Z",
  fill: "#9E5126"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M44.961 71.3019L45.3179 71.5679C49.2659 74.4939 51.128 79.4639 50.071 84.2659L46.109 102.242L21.2729 100.898L26.3619 77.2939C26.4179 77.1189 26.474 76.9439 26.53 76.7689C29.162 69.2089 38.528 66.5349 44.961 71.3019Z",
  fill: "url(#paint0_linear_31451_19906)"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M53.62 64.3789C53.396 64.3789 53.249 64.7149 53.487 64.8479C54.026 65.1419 54.558 65.4359 55.097 65.7299C55.139 65.7509 55.181 65.7649 55.216 65.7649C55.44 65.7649 55.587 65.4289 55.349 65.2959C54.81 65.0019 54.278 64.7079 53.739 64.4139C53.697 64.3929 53.655 64.3789 53.62 64.3789Z",
  fill: "#9E5126"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M72.317 89.7189C72.919 89.8869 73.528 89.7959 74.032 89.5089C74.536 89.2219 74.928 88.7529 75.096 88.1509L79.219 73.3739L78.785 72.5969L75.663 71.7219L74.879 72.1629L70.756 86.9399C70.42 88.1369 71.12 89.3829 72.324 89.7189H72.317Z",
  fill: "#2F3A49"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M74.8721 72.17L79.2191 73.381L80.8431 67.543L76.5381 66.199L74.8721 72.17Z",
  fill: "#AC41D8"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M81.9769 70.273C90.3623 70.273 97.1599 63.4753 97.1599 55.09C97.1599 46.7046 90.3623 39.907 81.9769 39.907C73.5916 39.907 66.7939 46.7046 66.7939 55.09C66.7939 63.4753 73.5916 70.273 81.9769 70.273Z",
  fill: "#C6F4DB"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M89.9641 46.529C87.7311 44.737 84.8261 43.869 81.6411 43.806C81.3751 43.806 81.1581 43.603 81.1231 43.337L81.0461 42.714C81.0041 42.385 81.2701 42.133 81.5991 42.112C83.0411 42 87.1641 42.217 90.8111 45.528C91.0561 45.752 91.0981 46.123 90.9091 46.396C90.6921 46.704 90.2581 46.76 89.9641 46.529Z",
  fill: "white"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M79.2059 44.097L79.5035 44.0518C79.9393 43.9856 80.2388 43.5787 80.1726 43.1429C80.1064 42.7072 79.6995 42.4077 79.2638 42.4739L78.9662 42.5191C78.5305 42.5853 78.2309 42.9922 78.2971 43.4279C78.3633 43.8636 78.7702 44.1632 79.2059 44.097Z",
  fill: "white"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M68.7471 62.5449C72.8701 69.8529 82.1311 72.4289 89.4321 68.3129L88.2841 66.2689C82.0611 69.1459 74.6341 67.0739 70.7911 61.3899L68.7471 62.5379V62.5449Z",
  fill: "white"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M88.2839 66.269L89.4319 68.313C96.7399 64.19 99.3159 54.929 95.1999 47.628C95.1019 47.46 95.0039 47.292 94.8989 47.124C94.9899 47.299 95.0739 47.474 95.1579 47.649C98.1959 54.222 95.7179 62.132 89.3059 65.744C88.9699 65.933 88.6269 66.108 88.2839 66.269Z",
  fill: "#DCDDE0"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M70.7911 61.3971C70.5811 61.0821 70.3781 60.7531 70.1891 60.4171C66.5701 53.9981 68.5441 45.9551 74.5431 41.9021C74.7041 41.7901 74.8721 41.6851 75.0331 41.5801C74.8581 41.6711 74.6901 41.7621 74.5151 41.8601C67.2071 45.9831 64.6311 55.2441 68.7471 62.5451L70.7911 61.3971Z",
  fill: "#DCDDE0"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M89.831 69.013C91.714 67.956 93.331 66.556 94.633 64.862C95.893 63.224 96.817 61.383 97.377 59.381C97.937 57.379 98.098 55.328 97.867 53.27C97.622 51.142 96.964 49.112 95.907 47.229C94.85 45.346 93.45 43.729 91.756 42.427C90.118 41.167 88.277 40.243 86.275 39.683C84.273 39.123 82.222 38.962 80.164 39.193C78.036 39.438 76.006 40.096 74.123 41.153C72.24 42.21 70.623 43.61 69.321 45.304C68.061 46.942 67.137 48.783 66.577 50.785C66.017 52.787 65.856 54.838 66.087 56.896C66.332 59.024 66.99 61.054 68.047 62.937C69.104 64.82 70.504 66.437 72.198 67.739C73.836 68.999 75.677 69.923 77.679 70.483C79.681 71.043 81.732 71.204 83.79 70.973C85.918 70.728 87.948 70.07 89.831 69.013ZM74.914 42.56C76.608 41.608 78.435 41.013 80.346 40.796C82.194 40.586 84.042 40.733 85.841 41.237C87.64 41.741 89.299 42.567 90.769 43.701C92.295 44.877 93.548 46.333 94.5 48.02C95.452 49.707 96.047 51.541 96.264 53.452C96.474 55.3 96.327 57.148 95.823 58.947C95.319 60.746 94.493 62.405 93.359 63.875C92.183 65.401 90.727 66.654 89.04 67.606C87.353 68.558 85.519 69.153 83.608 69.37C81.76 69.58 79.912 69.433 78.113 68.929C76.314 68.425 74.655 67.599 73.185 66.465C71.659 65.289 70.406 63.833 69.454 62.146C68.502 60.452 67.907 58.625 67.69 56.714C67.48 54.866 67.627 53.018 68.131 51.219C68.635 49.42 69.461 47.761 70.595 46.291C71.771 44.765 73.227 43.512 74.914 42.56Z",
  fill: "#2D2D2D"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M77.217 85.4911L63.861 103.04C63.392 103.656 62.972 104.314 62.545 104.958C60.536 107.961 56.119 108.472 53.599 105.7L53.543 105.637L33.019 85.7501L40.635 78.9951L57.771 95.0671L70.644 82.1801L77.217 85.4911Z",
  fill: "#C1813E"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M68.614 85.715C68.824 84.189 69.867 81.102 70.504 79.583C70.7 79.107 70.91 78.638 71.085 78.162C71.19 77.882 71.232 77.287 71.463 77.07C72.387 76.195 72.485 78.036 72.541 78.526C72.632 79.317 72.765 80.787 73.969 80.325C75.376 79.786 75.943 78.393 76.496 77.189C76.895 76.328 78.008 73.836 79.366 74.186C80.199 74.403 80.682 75.943 80.941 76.608C82.516 80.731 79.275 84.553 76.195 87.493C75.502 88.151 73.703 88.809 72.961 89.418",
  fill: "#C1813E"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M32.2629 76.0549C31.9199 76.4189 31.6049 76.8249 31.3389 77.2869C30.0229 79.5619 30.2399 82.4109 31.8849 84.4549L39.6619 94.5629L49.9729 87.1219L41.9089 76.6289C41.6989 76.3489 41.4679 76.0899 41.2229 75.8589C38.6889 73.4369 34.6499 73.5699 32.2699 76.0549",
  fill: "url(#paint1_linear_31451_19906)"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "M151.585 109.242L131.523 103.138V53.0598L151.893 61.1448L151.585 109.242Z",
  fill: "#9E3ACC"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M173.516 116.662L153.447 110.551V60.48L173.824 68.558L173.516 116.662Z",
  fill: "#9E3ACC"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M150.885 161.462L130.816 155.358V105.28L151.2 111.944L150.885 161.462Z",
  fill: "#9E3ACC"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M172.816 169.295L152.747 163.184V113.113L173.124 119.728L172.816 169.295Z",
  fill: "#9E3ACC"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.44,
  d: "M81.865 104.587L59.157 159.453",
  stroke: "#005434",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.44,
  d: "M92.4209 104.769L90.6289 173.334",
  stroke: "#005434",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.44,
  d: "M103.572 104.286L125.685 161.973",
  stroke: "#005434",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.44,
  d: "M68.7261 109.242L119.693 108.598",
  stroke: "#005434",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.44,
  d: "M62.6851 117.495L125.447 116.802",
  stroke: "#005434",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.44,
  d: "M59.157 128.709L125.447 127.575",
  stroke: "#005434",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.44,
  d: "M59.157 144.837L125.685 143.577",
  stroke: "#005434",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  d: "M74.9141 42.5598L75.2851 67.4728",
  stroke: "#00AD66",
  strokeMiterlimit: 10
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  d: "M180.39 194.985L125.762 173.32V33.5229L182.637 56.084L180.39 194.985Z",
  fill: "#F4B01A"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  d: "M174.908 115.204L174.079 116.314C173.662 116.872 173.777 117.661 174.335 118.078C174.892 118.494 175.682 118.379 176.098 117.822L176.927 116.711C177.344 116.154 177.229 115.364 176.672 114.948C176.114 114.532 175.324 114.646 174.908 115.204Z",
  fill: "black"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  d: "M175.261 116.037L166.665 113.716C165.456 113.39 164.211 114.105 163.884 115.315C163.558 116.524 164.273 117.769 165.483 118.095L174.079 120.416C175.288 120.743 176.533 120.027 176.86 118.818C177.186 117.609 176.471 116.364 175.261 116.037Z",
  fill: "#2D2D2D"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  d: "M164.22 115.395C164.22 115.395 165.018 114.135 166.74 114.639L173.824 116.494",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_31451_19906",
  x1: 21.2659,
  y1: 85.5819,
  x2: 50.358,
  y2: 85.5819,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#002E12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#006C43"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_31451_19906",
  x1: 35.1805,
  y1: 89.7823,
  x2: 43.8307,
  y2: 75.2713,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#002E12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#006C43"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOnboardingVistoriaSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/onboarding-vistoria-search.da5e520d5b889da011461b94deefd7bf.svg";